import { createListActionTypes } from './Constants';

export function listOptionsRequest() {
	return {
		type: createListActionTypes.LIST_OPTIONS_REQUEST,
	};
}

export function listOptionsSuccess(listOptions) {
	return {
		type: createListActionTypes.LIST_OPTIONS_SUCCESS,
		payload: {
			listOptions,
		},
	};
}

export function listOptionsError() {
	return {
		type: createListActionTypes.LIST_OPTIONS_ERROR,
	};
}

export function wordSuggestionRequest(word, languageFrom, languageTo, id, column) {
	return {
		type: createListActionTypes.WORD_SUGGESTION_REQUEST,
		payload: {
			word,
			languageFrom,
			languageTo,
			id,
			column,
		},
	};
}

export function wordSuggestionSuccess(suggestions) {
	return {
		type: createListActionTypes.WORD_SUGGESTION_SUCCESS,
		payload: {
			suggestions,
		},
	};
}

export function wordSuggestionError() {
	return {
		type: createListActionTypes.WORD_SUGGESTION_ERROR,
	};
}

export function createListRequest(listData, listId, createList) {
	return {
		type: createListActionTypes.CREATE_LIST_REQUEST,
		payload: {
			listData,
			listId,
			createList,
		},
	};
}

export function createListSuccess(createdList) {
	return {
		type: createListActionTypes.CREATE_LIST_SUCCESS,
		payload: {
			createdList,
		},
	};
}

export function createListError() {
	return {
		type: createListActionTypes.CREATE_LIST_ERROR,
	};
}

export function deleteDraftListRequest(listId) {
	return {
		type: createListActionTypes.DELETE_DRAFT_LIST_REQUEST,
		payload: {
			listId,
		},
	};
}

export function deleteDraftListSuccess() {
	return {
		type: createListActionTypes.DELETE_DRAFT_LIST_SUCCESS,
	};
}

export function deleteDraftListError() {
	return {
		type: createListActionTypes.DELETE_DRAFT_LIST_ERROR,
	};
}

export function editListDataRequest(listId) {
	return {
		type: createListActionTypes.EDIT_LIST_DATA_REQUEST,
		payload: {
			listId,
		},
	};
}

export function editListDataSuccess(listDetails) {
	return {
		type: createListActionTypes.EDIT_LIST_DATA_SUCCESS,
		payload: {
			listDetails,
		},
	};
}

export function editListDataError() {
	return {
		type: createListActionTypes.EDIT_LIST_DATA_ERROR,
	};
}

export function setAddImageModal(modalStatus, itemId) {
	return {
		type: createListActionTypes.SET_ADD_IMAGE_MODAL,
		error: true,
		payload: {
			modalStatus,
			itemId,
		},
	};
}

export function saveImage(imageSrc) {
	return {
		type: createListActionTypes.SET_ADD_IMAGE_MODAL,
		payload: {
			imageSrc,
		},
	};
}

export function setImageOverviewModal(modalStatus, itemId, image, deletedItemId) {
	return {
		type: createListActionTypes.SET_IMAGE_OVERVIEW_MODAL,
		payload: {
			modalStatus,
			itemId,
			image,
			deletedItemId,
		},
	};
}

export function cleanListState() {
	return {
		type: createListActionTypes.CLEAN_LIST_STATE,
	};
}

export function deleteUploadedImage() {
	return {
		type: createListActionTypes.DELETE_UPLOADED_IMAGE,
	};
}

export function toggleImportModal(open, importedWords = null) {
	return {
		type: createListActionTypes.TOGGLE_IMPORT_MODAL,
		payload: {
			open,
			importedWords,
		},
	};
}

export function closeCreateListPage() {
	return {
		type: createListActionTypes.CLOSE_LIST_PAGE,
	};
}

export function setListWords(listWords) {
	return {
		type: createListActionTypes.SET_LIST_WORDS,
		payload: {
			listWords,
		},
	};
}

export function addCreatedChapter(newChapter) {
	return {
		type: createListActionTypes.SET_NEW_CREATED_CHAPTER,
		payload: {
			newChapter,
		},
	};
}

export function setPreselectedOptions(data) {
	return {
		type: createListActionTypes.SET_CREATE_LIST_PRESELECTED_OPTIONS,
		payload: {
			data,
		},
	};
}
